module.exports = __webpack_public_path__ + "img/tour-36.c49334ec.png";